module.exports = "<h2 class=nn-base-heading-medium><span ng-if=!url ng-transclude></span> <a ng-if=url ng-href=\"{{ url }}\" rel=\"{{ rel || '' }}\" ng-transclude></a></h2>"


//////////////////
// WEBPACK FOOTER
// ./app/components/nn-base-components/nn-base-heading-medium/nn-base-heading-medium.directive.html
// module id = 954
// module chunks = 0